import { StoreSubject } from "../../../../src/lib/store";

export type PlayScope = "pattern" | "range" | "scene" | "project";

export type LabTransportState = {
  armed: boolean;
  /** Enable button shows restart affordance after first successful boot. */
  audioStarted: boolean;
  playing: boolean;
  playScope: PlayScope | null;
  /** Coarse playhead for chrome (time display). Grid paints via imperative API. */
  playhead: { patternId: string; row: number } | null;
  bpm: number;
  stepDivision: number;
  patternSteps: number;
  loop: boolean;
  followPlayhead: boolean;
  /**
   * Step-record arm: piano typing writes full notes + oneshot audition;
   * arrows move by cell; focus ring turns orange.
   */
  armMode: boolean;
  /** Transport toolbar mic → new sampler track (exclusive with Author record). */
  micRecording: boolean;
  /** Sampler Author mic replace-sample session (exclusive with toolbar record). */
  authorMicRecording: boolean;
  /** Formatted mm:ss for the transport clock. */
  timeCurrent: string;
  timePattern: string;
  timeComposition: string;
  timeTitle: string;
};

const initial: LabTransportState = {
  armed: false,
  audioStarted: false,
  playing: false,
  playScope: null,
  playhead: null,
  bpm: 120,
  stepDivision: 16,
  patternSteps: 16,
  loop: true,
  followPlayhead: false,
  armMode: false,
  micRecording: false,
  authorMicRecording: false,
  timeCurrent: "00:00",
  timePattern: "00:00",
  timeComposition: "00:00",
  timeTitle: "Cursor or playback · pattern length · composition length",
};

export const transportStore = new StoreSubject<LabTransportState>(initial);

export function patchTransport(partial: Partial<LabTransportState>): void {
  transportStore.next({ ...transportStore.getValue(), ...partial });
}
